<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.especialidade"
        ref="RkmDataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                @click="edit(item.id)"
                authorize="update-cadastro-especialidade"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="!!item.ativo"
                @click="deactivate(item.id)"
                authorize="update-cadastro-especialidade"
                color="dark"
                small
                title="Inativar"
            >
                <rkm-icon icon="ban" />
            </rkm-button>

            <rkm-button
                v-else
                @click="activate(item.id)"
                authorize="update-cadastro-especialidade"
                color="success"
                small
                title="Ativar"
            >
                <rkm-icon icon="check-circle" />
            </rkm-button>

            <rkm-button
                @click="destroy(item.id)"
                authorize="destroy-cadastro-especialidade"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {key: 'nome', name: 'especialidade.nome', label: 'Nome', searchable: true, sortable: true},
                {key: 'ocupacaoDescricao', name: 'ocupacaoDescricao', label: 'CBO', searchable: true, sortable: true},
                {key: 'permiteIntegracaoConectasusCidadao', name: 'permiteIntegracaoConectasusCidadao', label: 'ConectaSUS Cidadão', searchable: true, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    created() {
        this.repositories = {
            especialidade: this.getConectaSusRepository('cadastro.especialidade')
        }
    },
    methods: {
        edit(id) {
            this.$router.push({name: 'cadastro-especialidade-edit', params: {id: id}})
        },
        activate(id) {
            const activate = () => this.repositories.especialidade.activate(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.createNotification({
                color: 'success',
                confirm: activate,
                message: 'Deseja realmente ativar a especialidade?',
                onError: this.handleError,
                title: 'Confirmação de ativação',
                type: 'dialog',
            })
        },
        deactivate(id) {
            const deactivate = () => this.repositories.especialidade.deactivate(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.createNotification({
                    color: 'danger',
                    confirm: deactivate,
                    message: 'Deseja realmente inativar a especialidade?',
                    onError: this.handleError,
                    title: 'Confirmação de inativação',
                    type: 'dialog',
                })
        },
        destroy(id) {
            const destroy = () => this.repositories.especialidade.destroy(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a especialidade?', destroy, this.handleError)
        },
    },
    mixins: [ error, repository ],
}
</script>